import axios from 'axios'

const BASE_URL = process.env.API_UREC_BASE_URL
const AUTH_TOKEN = '41d61edf-5163-46f7-a30c-c1cbf68a536f'

let enabledEventsCache = []
let enabledEventsCacheTimestamp = 0
const ONE_DAY = 24 * 60 * 60 * 1000

/**
 * @description 設定允許的事件名稱清單
 * @param {Array} events - 允許的事件名稱陣列
 */
const setEnabledEvents = (eventNames) => {
  enabledEventsCache = eventNames
}

/**
 * @description 取得允許的事件名稱清單（一天呼叫一次）
 * @returns {Promise<Array>} 允許的事件名稱陣列
 */
const getEnabledEvents = async () => {
  const now = Date.now()
  if (now - enabledEventsCacheTimestamp < ONE_DAY) return enabledEventsCache
  try {
    const res = await axios.get(`${BASE_URL}event/enabled`, {
      headers: { Authorization: `Bearer ${AUTH_TOKEN}` }
    })
    const eventNames = res.data.event_names || []
    setEnabledEvents(eventNames)
    enabledEventsCacheTimestamp = now
    // 回傳允許的事件名稱陣列
    console.log('UREC 初始化完成，允許事件數量:', eventNames.length)
    return eventNames
  } catch (error) {
    // 取得允許事件清單失敗
    console.error('UREC 初始化失敗:', error)
    return []
  }
}

/**
 * @description 上傳 UREC 事件日誌
 * @param {Array} events - 事件陣列
 * @returns {Promise<Object>} 上傳結果
 */
const postUrecEventLog = async (context, events) => {
  try {
    const enabledEvents = await getEnabledEvents()
    const filteredEvents = events.filter(event => enabledEvents.includes(event.event_name))
    if (filteredEvents.length === 0) {
      console.warn('postEventLog: 無符合允許清單的事件，略過上傳')
      return { event_count: 0 }
    }
    const isApp = context.store.state.isApp
    const deviceCode = context.store.state.deviceCode || ''
    const appServiceAccountId = context.store.state.appServiceAccountId
    const authUser = context.app.$auth && context.app.$auth.user ? context.app.$auth.user : {}
    const userId = authUser.AId || appServiceAccountId || ''
    const installationId = deviceCode || ''
    const appId = 'dailypro_web'
    const appVersion = context.env.version
    const platform = typeof isApp !== 'undefined' ? (isApp ? 'app' : 'web') : 'web'

    const eventsWithCommon = filteredEvents.map(event => {
      const e = { ...event }
      if (!e.user_id && userId) e.user_id = userId
      if (!e.installation_id && installationId) e.installation_id = installationId
      if (!e.app_info && (appId || appVersion)) {
        e.app_info = {}
        if (appId) e.app_info.id = appId
        if (appVersion) e.app_info.version = appVersion
      }
      if (!e.platform) e.platform = platform
      return e
    })
    const payload = { events: eventsWithCommon }
    const res = await axios.post(`${BASE_URL}event/log`, payload, {
      headers: {
        Authorization: `Bearer ${AUTH_TOKEN}`,
        'Content-Type': 'application/json'
      }
    })
    return res.data
  } catch (err) {
    console.error('postEventLog error', err)
    throw err
  }
}

export default (context, inject) => {
  inject('urec', {
    getEnabledEvents,
    setEnabledEvents,
    postUrecEventLog: (events) => postUrecEventLog(context, events)
  })
}
